import {
  mapGetCompanyEmailAddressesResponseType,
  useFindCompanyEmailAddressesSuspense,
} from '@api';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { buildMailtoHref } from './helpers';

type CompanyMailButtonPropsType = {
  companyId: string;
};

export const CompanyMailButton: React.FC<CompanyMailButtonPropsType> = ({
  companyId,
}) => {
  const { t } = useTranslation('companyDetails');
  const { data } = useFindCompanyEmailAddressesSuspense(companyId, {
    query: {
      select: (response) =>
        mapGetCompanyEmailAddressesResponseType(response),
    },
  });
  const href = buildMailtoHref(data.emails);
  const disabled = href === undefined;

  const label = t('COMPANY_MAIL_BUTTON.ARIA_LABEL');
  const tooltipLabel = disabled
    ? t('COMPANY_MAIL_BUTTON.TOOLTIP.NO_ADDRESSES')
    : t('COMPANY_MAIL_BUTTON.TOOLTIP.HAS_ADDRESSES');

  return (
    <Tooltip label={tooltipLabel}>
      <Button
        size="xs"
        color="blue"
        variant="outline"
        component="a"
        href={href}
        aria-label={label}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faEnvelope} />
      </Button>
    </Tooltip>
  );
};
